module.exports = __webpack_public_path__ + "files/9b86c5b85afaf7222f0e5c29dc55bb31.png";